import { File } from '../../../modules/file/model'
import { Service } from '../../../modules/config/model'
import { Advert as AdvertType } from '../../../modules/advert/model'

export const shouldDisplayThumbnail = (file: File, service: Service): boolean =>
  service === Service.Ulozto || service === Service.Pinkfile || !!file.thumbnail || !!file.preview

export const isAdvert = (item: File | AdvertType | undefined): boolean => item != undefined && !('name' in item) && 'position' in item
export const isFile = (item: File | AdvertType | undefined): boolean => item != undefined && 'name' in item
